import React from 'react';

type Props = {
  children: React.ReactNode;
};

export const BreadcrumbPage: React.FC<Props> = ({ children }) => {
  return <span aria-current='page'>{children}</span>;
};
